import CustomerInfoCard from "components/CustomerDetail/CustomerInfoCard";
import { connect } from "react-redux";
import { openCustomerModal } from "redux/modules/customerDetail";

const mapStateToProps = state => ({
  customer: state.customerDetail.customer
});

const mapDispatchToProps = dispatch => ({
  openCustomerModal: customer => {
    dispatch(openCustomerModal(customer));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomerInfoCard);



// WEBPACK FOOTER //
// ./src/containers/CustomerDetail/CustomerInfoCard/index.js